module.exports = __webpack_public_path__ + "img/notice_bg.5f0e4242.png";